import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { api } from '@/api/client'

interface Health {
  status: string
  app: string
  version: string
  environment: string
  serverTime: string
}

/** Φάση 0: επιβεβαιώνει ότι SPA και API μιλούν μεταξύ τους μέσω του nginx. */
export default function HealthPage() {
  const { t } = useTranslation()
  const { data, isPending, isError } = useQuery({
    queryKey: ['health'],
    queryFn: () => api.get<Health>('/health'),
  })

  return (
    <main className="mx-auto flex min-h-full max-w-md flex-col justify-center gap-6 p-6">
      <header>
        <h1 className="text-2xl font-semibold text-brand-700">{t('app.name')}</h1>
        <p className="mt-1 text-sm text-gray-500">{t('app.tagline')}</p>
      </header>

      <section className="rounded-xl border border-gray-200 p-4">
        <h2 className="mb-3 text-sm font-medium uppercase tracking-wide text-gray-500">
          {t('health.title')}
        </h2>

        {isPending && <p className="text-gray-500">{t('common.loading')}</p>}
        {isError && <p className="text-red-600">{t('health.failed')}</p>}

        {data && (
          <dl className="space-y-2 text-sm">
            <p className="font-medium text-brand-700">{t('health.connected')}</p>
            <div className="flex justify-between">
              <dt className="text-gray-500">{t('health.version')}</dt>
              <dd className="tabular-nums">{data.version}</dd>
            </div>
            <div className="flex justify-between">
              <dt className="text-gray-500">{t('health.environment')}</dt>
              <dd>{data.environment}</dd>
            </div>
            <div className="flex justify-between">
              <dt className="text-gray-500">{t('health.serverTime')}</dt>
              <dd className="tabular-nums">
                {new Intl.DateTimeFormat('el-GR', {
                  dateStyle: 'short',
                  timeStyle: 'medium',
                  timeZone: 'Europe/Athens',
                }).format(new Date(data.serverTime))}
              </dd>
            </div>
          </dl>
        )}
      </section>
    </main>
  )
}
